import {
  AddressType,
  PhoneNumberType,
  Organisation,
  OrganisationAddress,
  OrganisationPhoneNumber,
} from "@/api/SolarCloudApi";
import { v4 as uuid } from "uuid";

export function findDefaultOrganisationPhoneNumber(
  organisation: Organisation | undefined | null
): OrganisationPhoneNumber | undefined {
  if (organisation === undefined || organisation === null) {
    return undefined;
  }

  var defaultPhoneNumber: OrganisationPhoneNumber | undefined;

  if (organisation.phoneNumbers) {
    for (const phoneNumber of organisation.phoneNumbers) {
      if (!defaultPhoneNumber) {
        defaultPhoneNumber = phoneNumber;
      }

      switch (phoneNumber.type) {
        case PhoneNumberType.MOBILE:
          defaultPhoneNumber = phoneNumber;
          break;

        case PhoneNumberType.DEFAULT:
          if (
            defaultPhoneNumber.type !== PhoneNumberType.HOME &&
            defaultPhoneNumber.type !== PhoneNumberType.BUSINESS
          ) {
            defaultPhoneNumber = phoneNumber;
          }
          break;

        case PhoneNumberType.BUSINESS:
          if (defaultPhoneNumber.type !== PhoneNumberType.HOME) {
            defaultPhoneNumber = phoneNumber;
          }
          break;

        default:
          break;
      }
    }
  }

  return defaultPhoneNumber ? defaultPhoneNumber : {};
}

export function updateOrganisationPhoneNumbers(
  organisation: Partial<Organisation> | undefined,
  phoneNumber: OrganisationPhoneNumber | undefined
): OrganisationPhoneNumber[] | undefined {
  if (!phoneNumber) {
    return organisation?.phoneNumbers;
  }

  if (!organisation) {
    return [phoneNumber];
  }

  if (phoneNumber.uuid) {
    for (
      var index = 0;
      index < (organisation.phoneNumbers?.length ?? 0);
      ++index
    ) {
      if (organisation.phoneNumbers?.[index].uuid === phoneNumber.uuid) {
        const phoneNumbers = [...organisation.phoneNumbers];
        phoneNumbers[index] = phoneNumber;
        return phoneNumbers;
      }
    }
  }

  return [...(organisation.phoneNumbers ?? []), phoneNumber];
}

export function findDefaultOrganisationAddress(
  organisation: Organisation | undefined | null
): OrganisationAddress | undefined {
  if (organisation === undefined || organisation === null) {
    return undefined;
  }

  var defaultAddress: OrganisationAddress | undefined;

  if (organisation.addresses) {
    for (const address of organisation.addresses) {
      if (!defaultAddress) {
        defaultAddress = address;
      }

      switch (address.type) {
        case AddressType.HOME:
          defaultAddress = address;
          break;

        case AddressType.BUSINESS:
          if (defaultAddress.type !== AddressType.HOME) {
            defaultAddress = address;
          }
          break;

        case AddressType.POSTAL:
          if (
            defaultAddress.type !== AddressType.HOME &&
            defaultAddress.type !== AddressType.BUSINESS
          ) {
            defaultAddress = address;
          }
          break;

        default:
          break;
      }
    }
  }

  return defaultAddress ? defaultAddress : {};
}

export function updateOrganisationAddresses(
  organisation: Partial<Organisation> | undefined,
  address: OrganisationAddress | undefined
): OrganisationAddress[] | undefined {
  if (!address) {
    return organisation?.addresses;
  }

  if (!organisation) {
    return [address];
  }

  if (address.uuid) {
    for (
      var index = 0;
      index < (organisation.addresses?.length ?? 0);
      ++index
    ) {
      if (organisation.addresses?.[index].uuid === address.uuid) {
        const addresses = [...organisation.addresses];
        addresses[index] = address;
        return addresses;
      }
    }
  } else {
    address.uuid = uuid();
  }

  return [...(organisation.addresses ?? []), address];
}
